import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom"
import Footer from "../../shared/components/Footer";
import AdminHeader from './AdminHeader';
import { useStateValue } from "../../shared/state/StateProviders";
import AdminLogin from "./AdminLogin";
import Topbar from "../../shared/components/Topbar";
import Breadcrumb from "../../shared/components/Breadcrumb";
import AdminSidebar from './AdminSidebar';

export default function Adminlayout() {

  const [{ DIsLogin }, dispatch] = useStateValue();
  let navigate = useNavigate();

  useEffect(() => {
    if (DIsLogin) {
      // navigate("/administration/dashboard");
    }
  }, [DIsLogin]);

  useEffect(() => {
    if (localStorage.getItem("DToken") !== null && localStorage.getItem("LoginDetails") === 'Admin') {
      dispatch({
        type: "DLogin",
      });
    } else {
      dispatch({
        type: "DLogout",
      });
    }
  }, []);
  return (<>
    <Topbar />
    <AdminHeader />
    {DIsLogin ?
      <>
        <Breadcrumb />
        <div className="slidebar_and_component">
          <AdminSidebar />
          <div className="outlet_main_div">
            <Outlet />
          </div>
        </div>
      </>

      : <AdminLogin />}
    <Footer />
  </>)
}